var zo = zo || {};


// Home fold slider 
//-----------------------------------------------------------------
zo.foldSlider = function() {

    var $slider = $('.js_foldSlider').removeClass('loading');

    if (!$slider.length) {
        return;
    }

    $slider.slick({
        autoplay: true,
        fade: true,
        speed: 1000,
        infinite: true,
        dots: true,
        arrows: true,
        adaptiveHeight: false,
        slide: '.fold__item',
        appendDots: $('.fold__dots'),
        appendArrows: $('.fold__arrows'),
        touchThreshold: 12,
        prevArrow: '<a class="fold__arrows_item arrow-prev"><i class="icon-arrow-small-left"></i></a>',
        nextArrow: '<a class="fold__arrows_item arrow-next"><i class="icon-arrow-small-right"></i></a>',
        cssEase: 'cubic-bezier(.84,.2,.6,1.04)'
    });

};




zo.tabs = function() {


    var activeIndex = $('.active-tab').index(),
        $contentlis = $('.tabs__content .tabs__wrap'),
        $tabslis = $('.tabs li');

    

    // Show content of active tab on loads
    $contentlis.eq(activeIndex).show();

    $('.tabs').on('click', 'li', function (e) {
    var $current = $(e.currentTarget),
        index = $current.index();

    $tabslis.removeClass('active-tab');
    $current.addClass('active-tab');
    $contentlis.hide().eq(index).show();
     });

};


zo.goDown = function() {

  $(document).ready(function(){
  // Add smooth scrolling to all links
  $(".go_down").on('click', function(event) {

    // Make sure this.hash has a value before overriding default behavior
    if (this.hash !== "") {
      // Prevent default anchor click behavior
      event.preventDefault();

      // Store hash
      var hash = this.hash;

      // Using jQuery's animate() method to add smooth page scroll
      // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
      $('html, body').animate({
        scrollTop: $(hash).offset().top
      }, 800, function(){

        // Add hash (#) to URL when done scrolling (default click behavior)
        window.location.hash = hash;
      });
    } // End if
  });
  });


}


$(document).ready(function (){
    zo.foldSlider();
    zo.tabs();
    zo.goDown();
});

